/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import TablePagination from "@material-ui/core/TablePagination";
import { makeStyles } from "@material-ui/core/styles";

import { defaultPasscodeTheme } from "../../../constants/passCodeUtils";

const headRows = translate => [
  { id: "changeBy", label: translate.changedBy },
  { id: "changeDate", label: translate.changeDate },
  { id: "newValue", label: translate.newValue },
  { id: "oldValue", label: translate.oldValue },
  { id: "param", label: translate.changedValue },
];

const useStyles = makeStyles(theme => ({
  label: {
    fontWeight: "bold",
    minWidth: 150,
    maxWidth: 150,
  },
  cell: {
    minWidth: 200,
    maxWidth: 200,
  },
  ...defaultPasscodeTheme(theme),
}));

const PMInternalInfo = ({ conference, translate }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(conference.changeLog ? conference.changeLog : []);

  useEffect(() => {
    if (rows !== conference.changeLog) {
      setRows(conference.changeLog);
    }
  }, [setRows, rows, conference]);

  const handleChangePage = newPage => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
  };

  const classes = useStyles();
  return rows ? (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {headRows(translate).map((cell, idx) => (
              <TableCell key={cell.label}>
                <div className={classes.label + " " + classes["cell" + idx]}>{cell.label}</div>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows
            .map((row, index) => (
              <TableRow className={classes.cell} key={"rows" + index}>
                {headRows(translate).map((cell, cellIndex) => (
                  <TableCell key={"cells" + cellIndex} className={classes.cell}>
                    {cell.id === "param" ? translate[row[cell.id]] : row[cell.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))
            .reverse()
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          "aria-label": "Previous Page",
        }}
        nextIconButtonProps={{
          "aria-label": "Next Page",
        }}
        onChangePage={(event, newPage) => handleChangePage(newPage)}
        onChangeRowsPerPage={event => handleChangeRowsPerPage(event)}
      />
    </Paper>
  ) : null;
};

PMInternalInfo.propTypes = {
  conference: PropTypes.object.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMInternalInfo;
